import React, { useState, useRef } from 'react'
import './App.css';
// ASSETS
// import audioTrack from './assets/bach-g-minor-little.mp3';
// import Data from "./Data/data.json";

// COMPONENTS
import AnnotationSection from './Components/AnnotationSection/AnnotationSection';
import AudioControlsSection from './Components/AudioControlsSection/AudioControlsSection';
import CreditsSection from './Components/CreditsSection/CreditsSection';

const App = ({ Data }) => {

  // AUDIO TRACK REF
  const audRef = useRef(null);  //HTML media element
  // HOOKS
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false)
  const [timelineIndex, setTimelineIndex] = useState(0)
  const [frameIndex, setFrameIndex] = useState(0);
  // EVENT LISTENERS
  // fires any time position in audio track changes; saves time position in state and fetches appropriate refs
  const handleTimeUpdated = (e) => {
    const updatedTime = e.target.currentTime
    setCurrentTime(updatedTime)
    getSection(updatedTime);
  }
  // fires when audio track is loaded
  const handleDataLoaded = () => {
    setDataLoaded(true)
  }
  // fires when audio reaches end of track
  const handleEnded = () => {
    setIsPlaying(false)
  }
  // HELPER FUNCTIONS
  const getSection = (currentTime) => {
    Data.enableMod.filter(mod => mod.type === "interact")[0].interact.timelines.forEach((timeline, index) => {
      if (parseFloat(timeline.frames[0].in) <= parseFloat(currentTime) && parseFloat(currentTime) < parseFloat(timeline.frames[0].out)) {
        setTimelineIndex(index)
      }
      timeline.frames.forEach((frame, frameIndex) => {
        if (parseFloat(frame.in) <= parseFloat(currentTime) && parseFloat(currentTime) < parseFloat(frame.out)) {
          setFrameIndex(frameIndex)
        }
      })
    })
  }

  const formatSectionHeaderStr = (str) => {
    const formattedStr = str ? str.replace(/<br\s*\/?>/gi, ' ') : str
    return (formattedStr)
  }
  const updateTime = (time) => {
    setCurrentTime(parseFloat(time))
    audRef.current.currentTime = time
  }
  // converts time from seconds to 00:00:00 format
  const formatTime = (time) => {
    // const date = new Date(time)
    // date.setSeconds(time)
    // console.log(date)
    const minsCalc = Math.floor(parseFloat(time) / 60)
    const mins = minsCalc.toString().length < 2 ? ('0' + minsCalc) : minsCalc
    const secondsCalc = Math.round((parseFloat(time) % 60))
    const seconds = secondsCalc.toString().length < 2 ? ('0' + secondsCalc) : secondsCalc
    // const hundredthsCalc = Math.floor((parseFloat(time) % 1) * 100)
    // const hundredths = hundredthsCalc.toString().length < 2 ? ('0' + hundredthsCalc) : hundredthsCalc
    const curTime = `${mins}:${seconds}`
    return curTime
  }

  return (
    Data ?
      <div className="App">
        <audio
          controls
          onLoadedData={handleDataLoaded}
          onTimeUpdate={handleTimeUpdated}
          onEnded={handleEnded}
          ref={audRef}
          style={{ display: 'none' }}
        >
          <source
            src={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.media}
            // src={audioTrack}
            type="audio/mpeg"
          />
        </audio>
        <main className="main">
          <AudioControlsSection
            audRef={audRef}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
            setCurrentTime={setCurrentTime}
            currentTime={currentTime}
            dataLoaded={dataLoaded}
            Data={Data}
            timelineIndex={timelineIndex}
            frameIndex={frameIndex}
            formatSectionHeaderStr={formatSectionHeaderStr}
            updateTime={updateTime}
            formatTime={formatTime}
          />
          <AnnotationSection
            Data={Data}
            timelineIndex={timelineIndex}
            frameIndex={frameIndex}
            formatTime={formatTime}
            formatSectionHeaderStr={formatSectionHeaderStr}
            updateTime={updateTime}
          />
          <CreditsSection
            Data={Data}
            formatSectionHeaderStr={formatSectionHeaderStr}
          />
        </main>
      </div >
      :
      <div>
        "no data loaded"
      </div>
  );
}

export default App;